const appManagement = {
  loginName: "Login name",
  realName: "Name",
  nickName: "Nick name",
  gender: "Gender",
  birthDate: "Birthdate",
  width1: "90px",
  status: "Status",
  loginTime: "Last login time",
  createdOn: "Creation time",
  all: "All",
  enable: "Enable",
  disable: "Disable",
  restPassword: "Reset password",
  restPwd: {
    updatePwdSuccess: "Password reset complete",
    msg1: "Reset password to 12345678"
  },
  detailDilago: {
    appTitle: "APP User details",
    personTitle: "Personal information",
    carTitle: "User vehicle",
    notifyTitle: "Notification message",
    maxSpeed: "Speed limit",
    securityModeAlarm: "Security mode alarm",
    deviceUnplugReminder: "Device unplug reminder",
    safetyReminder: "Security reminder",
    geoFenceReminder: "Geofence alarm",
    deviceOfflineReminder: "Device offline/online alarm",
    activityReminder: "Activities  alarm",
    systemMessage: "System message",
    overSpeedAlarm: "Overspeed alarm",
    open: "Dialog open",
    off: "Dialog off"
  }
} 
export default appManagement